<div
  *ngIf="isLoading"
  class="h-[700px] w-full flex items-center justify-center"
>
  <app-loading></app-loading>
</div>
<div
  *ngIf="!isLoading && companies.length === 0"
  class="flex flex-col items-center justify-center py-20 text-gray-500 min-h-[700px]"
>
  <svg
    class="w-16 h-16 mb-4 text-gray-300"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V7M16 3l-4 4-4-4"
    />
  </svg>
  <p class="text-lg font-medium">
    No hay compañías disponibles en este momento
  </p>
  <p class="text-sm">Vuelve más tarde para descubrir nuevas oportunidades.</p>
</div>
<div
  *ngIf="!isLoading && companies.length > 0"
  class="flex flex-col items-center space-y-6 p-6 bg-gray-50 min-h-[700px]"
>
  <div
    *ngFor="let company of companies"
    class="w-full max-w-6xl bg-white rounded border border-gray-200 overflow-hidden flex flex-col"
  >
    <div class="w-full h-14 md:h-20">
      <img
        [src]="companyBanner(company)"
        [alt]="company.commercialName + ' banner'"
        class="w-full h-full object-cover rounded-t"
      />
    </div>
    <div class="flex flex-col md:flex-row p-4">
      <div
        class="flex items-center justify-center bg-gray-50 p-2 md:w-1/4 rounded-xl shrink-0 mb-4 md:mb-0"
      >
        <img
          class="w-24 h-24 object-contain rounded-lg border border-gray-200"
          [src]="companyImage(company)"
          [alt]="company.commercialName"
        />
      </div>
      <div class="flex-1 p-6 flex flex-col justify-start">
        <div class="grow">
          <div
            class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2"
          >
            <h3 class="text-xl font-semibold text-gray-800">
              {{ company.commercialName }}
            </h3>
            @if(!isVerified(company)){
            <div
              class="flex items-center text-yellow-500 font-medium text-sm bg-yellow-100 rounded-full px-4 py-1 shrink-0"
            >
              <ng-icon name="heroInformationCircle" size="20"></ng-icon>
              <p class="text-sm hover:underline ml-2 cursor-pointer">
                No verificado
              </p>
            </div>
            } @else{
            <div
              class="flex items-center text-green-500 font-medium text-sm bg-green-100 rounded-full px-4 py-1 shrink-0"
            >
              <ng-icon name="heroCheckBadge" size="20"></ng-icon>
              <p class="text-sm ml-2">Verificado</p>
            </div>
            }
          </div>
          <p class="text-sm text-gray-500 italic mb-2">
            "{{ company.slogan || "Innovando contigo" }}"
          </p>
          <p class="text-sm font-medium text-blue-600 mb-1">
            {{ company.businessLine }}
          </p>
          <p class="text-xs text-gray-400 mb-4">
            {{ company.district }}, {{ company.province }},
            {{ company.country }}
          </p>
          <div class="mt-4 text-xs text-gray-500 space-y-1">
            <p>
              <span class="font-semibold">Razón social:</span>
              {{ company.socialReason }}
            </p>
            <p><span class="font-semibold">RUC:</span> {{ company.ruc }}</p>
            <p><span class="font-semibold">Email:</span> {{ company.email }}</p>
          </div>
        </div>
        <div class="mt-4 flex w-full **justify-center md:justify-end**">
          <a
            [routerLink]="['/companies', company.idCompany]"
            class="px-4 py-2 bg-primary text-white text-sm rounded hover:bg-primary/90 cursor-pointer transition shrink-0"
          >
            Ver compañia
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
